import React from "react";
import NextPage from "./NextPage";
import PreviousPage from "./PreviousPage";
import Pages from "./Pages";

export default props => {
  if (!props.lastPage || props.lastPage <= 1) {
    return null;
  }
  return (
    <nav className={`pagination ${props.modifyClasses}`}>
      <NextPage {...props} />
      <PreviousPage {...props} />
      <Pages {...props} />
    </nav>
  );
};



// WEBPACK FOOTER //
// ./src/components/Pagination/index.js